import React from 'react';
import { CircularProgress, Dialog, DialogContent } from '@mui/material';

import { makeStyles } from '@mui/styles';

import { useSelector } from 'src/redux/store';

const useStyles = makeStyles({
  root: {
    zIndex: '1301!important',
  },
  dialogPaper: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  dialogContentRoot: {
    backgroundColor: 'transparent',
  },
  CircularProgress: {
    color: 'white',
  },
});

const BlockingLoader = (props) => {
  const classes = useStyles();
  const { loaderCount } = useSelector((state) => state.blockingLoader);
  return (
    <Dialog
      id="dialog-loading"
      open={loaderCount > 0}
      // disableBackdropClick={true}
      disableEscapeKeyDown={true}
      classes={{ root: classes.root, paper: classes.dialogPaper }}
    >
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <CircularProgress
          classes={{
            colorPrimary: classes.CircularProgress,
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BlockingLoader;
